import { Injectable } from '@angular/core';
import { BaseProvider } from '../../../../shared/providers/base-provider';
import { StdFooterNotifier } from './std-footer-notifier';
import { StdFooterState } from './std-footer-state';

/**
 * StdFooterProvider — provider del pie agnóstico del layout STD.
 *
 * Provee el notifier que el comunicador (selección de alertas y momentos)
 * utiliza para montar contenido dentro del pie. El pie en sí no decide nada.
 */
@Injectable()
export class StdFooterProvider extends BaseProvider<
  StdFooterNotifier,
  StdFooterState
> {
  constructor() {
    super(StdFooterNotifier);
  }
}
